package org.bsvac.bsvac_kmp.data.models

import androidx.compose.animation.core.rememberTransition

enum class BoroughModel(val displayString: String) {
    BK_NORTH("BROOKLYN NORTH"),
    BK_CENTRAL("BROOKLYN CENTRAL"),
    QUEENS_WEST("QUEENS WEST");

    companion object {
        fun validEntries(selectedAgency: AgencyModel?): List<BoroughModel> {
            return when (selectedAgency) {
                null -> emptyList()
                AgencyModel.BSVAC -> listOf(BK_NORTH, BK_CENTRAL)
                AgencyModel.GVEMS -> listOf(BK_NORTH, QUEENS_WEST)
            }
        }
    }
}

